import { render, staticRenderFns } from "./Project19Zh.vue?vue&type=template&id=6c2c500b&scoped=true&"
import script from "./Project19Zh.vue?vue&type=script&lang=js&"
export * from "./Project19Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project19Zh.vue?vue&type=style&index=0&id=6c2c500b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c500b",
  null
  
)

export default component.exports